const ILLUSTRATION = 'https://customer-assets.emergentagent.com/job_artist-epk-premium/artifacts/2xo86gdn_Gemini_Generated_Image_s2w1pms2w1pms2w1.png';

export default function Identity() {
  return (
    <section id="identity" className="identity-section" data-testid="identity-section">
      <div className="identity-grid">
        <div className="identity-left">

          {/* Top group — eyebrow + heading + body */}
          <div>
            <div className="eyebrow">
              <div className="eyebrow-line" />
              <span className="eyebrow-text">01 — IDENTITY</span>
            </div>

            <h2 className="identity-heading">
              Township memory meets <em>elevated electronic luxury.</em>
            </h2>

            <div className="identity-body">
              <p>Born in Ezibeleni, Queenstown, and shaped by a life in motion across continents, Lulo Lonke's sound is the sum of everything that couldn't be bought: improvised percussion from used cans, jazz drifting from a nearby carwash, and rhythmic chants and melodies from street games echoing through dusty afternoons.</p>
              <p>His artistry sits at the meeting point of memory and reinvention — deeply rooted in South African musical heritage, yet forward-facing in its embrace of electronic texture, rhythmic precision, and cinematic storytelling.</p>
              <p className="identity-closing-line">This is not just music. This is a life, made sonic.</p>
            </div>
          </div>

          {/* Bottom group — genre tags, always flush to bottom of column */}
          <div className="identity-tags">
            <span className="tag" data-testid="genre-afro-house">AFRO HOUSE</span>
            <span className="tag" data-testid="genre-afro-tech">AFRO TECH</span>
            <span className="tag" data-testid="genre-deep-house">DEEP HOUSE</span>
            <span className="tag" data-testid="genre-amapiano">AMAPIANO</span>
            <span className="tag" data-testid="genre-gqom">GQOM</span>
          </div>

        </div>

        <div className="identity-image-col">
          <img src={ILLUSTRATION} alt="Lulo Lonke - Artist Portrait" loading="lazy" />
        </div>
      </div>
    </section>
  );
}
